// utils/encrypt.js (React)
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY || "ppshope-32-char-secret-key-94444188";

export function encryptData(data) {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  return ciphertext;
}